import * as React from 'react';
import { useStores } from '../../../../utils/hooks';
import { ListLayoutComponent } from './list-layout-component';
export var ActivitySpannedTileList = function (_a) {
  var activityTiles = _a.activityTiles;
  var _b = useStores(),
    searchCriteriaStore = _b.searchCriteriaStore,
    analytics = _b.analytics;
  var handleSrpTileClick = function (activityTile) {
    searchCriteriaStore.scrollPosition = window.pageYOffset;
    if (activityTile.clientSideAnalytics) {
      analytics.trackEvent(activityTile.clientSideAnalytics.referrerId, activityTile.clientSideAnalytics.linkName, analytics.omnitureData);
    }
  };
  return activityTiles.length > 0 ? React.createElement("section", {
    className: "activity-spanned-tile-list",
    "data-testid": "activity-spanned-tile-list--section"
  }, React.createElement(ListLayoutComponent, {
    activityTiles: activityTiles,
    onClick: handleSrpTileClick
  })) : null;
};